<template>
    <div class="pb-3">
        <slot name="title">
            <h4 v-if="title">
                {{ title }}
            </h4>
        </slot>
        <div class="text-gray-900 leading-tight text-base xs:text-lg">
            <slot name="data" />
        </div>
        <div
            tabindex="0"
            class="collapse"
            :class="{'collapse-open':isOpen, 'collapse-close':!isOpen}"
        >
            <div class="collapse-content px-0">
                <div
                    class="bg-green-100 border-dashed border rounded md:rounded-md border-secondary px-3 pt-4 xs:px-4 pb-4 mt-2"
                >
                    <slot name="inputs" />
                    <slot name="custom">
                        <div class="flex justify-end mt-3">
                            <button
                                v-if="needResetBtn"
                                class="btn-text text-primary border-b border-primary"
                                type="button"
                                @click="resetValues()"
                            >
                                取消變更
                            </button>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
        <div
            v-if="btnText"
            class="flex justify-end"
        >
            <button
                v-if="!isOpen"
                :disabled="isLoadingData"
                class="btn text-gray-75 btn-sm rounded-full"
                :class="buttonPosition"
                type="button"
                @click="$emit('update:isOpen', true)"
            >
                {{ btnText }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        idx: {
            type: Number,
            default: null,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        isLoadingData: {
            type: Boolean,
            default: false,
        },
        buttonPosition: {
            type: String,
            default: 'md:-mt-8',
        },
        btnText: {
            type: String,
            default: '變更',
        },
        needResetBtn: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['update:isOpen', 'resetValues'],
    setup(props, { emit }) {
        const resetValues = () => {
            emit('update:isOpen', false);
            emit('resetValues', props.idx);
        };
        return { resetValues };
    },
};
</script>
<style lang="scss" scoped>
h4 {
    @apply mb-3 mt-4 md:mt-5;
}

.collapse.collapse-open {
    overflow: initial;

    .collapse-content {
        overflow: initial;
    }
}

.gray-dashed:not(:first-child) {
    @apply border-t border-dashed border-gray-200 pt-3 mt-3;
}
</style>
